import React, { useEffect, useState } from 'react';
import PageContainer from 'components/layout/PageContainer';
import { createTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { AdminNavbar } from '../../modules/tt-navmenu';
import { Breadcrumb } from 'core/Breadcrumb';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Users } from './Users';
import { AllItems } from './AllItems';
import { Tools } from './Tools';
import { ChatBot } from './ChatBot';
import { FceUsers } from './FceUsers';
import { FceContracts } from './FceContracts';
import { FceAdmin } from './FceAdmin';
import { Companies } from './Companies';
import styles from './AdminRoutes.module.scss';
import { useLazyQuery } from '@apollo/client';
import { GET_CURRENT_USER } from '../../api';
import { openNotification } from 'tt-ui-lib/core';
import { AdminContent } from './AdminContent';
import { useSelectedContext } from '../../context/contextSelector';
import CommunicationsAdminPage from 'core/views/admin/Communications';

const ADMIN_ROUTES_INFO = [
  {
    path: '/users',
    element: <Users />,
    name: 'Users',
  },
  {
    path: '/all-items',
    element: <AllItems />,
    name: 'All Items',
  },
  {
    path: '/communications',
    element: <CommunicationsAdminPage />,
    name: 'Communications',
  },
  {
    path: '/tools',
    element: <Tools />,
    name: 'Tools',
  },
  {
    path: '/chat-bot',
    element: <ChatBot />,
    name: 'Chat-Bot',
  },
  {
    path: '/fce-users',
    element: <FceUsers />,
    name: 'Fce Users',
  },
  {
    path: '/fce-contracts',
    element: <FceContracts />,
    name: 'Fce Contacts',
  },
  {
    path: '/fce-admin',
    element: <FceAdmin />,
    name: 'Fce Admin',
  },
  {
    path: '/companies',
    element: <Companies />,
    name: 'Companies',
  },
  {
    path: '/content',
    element: <AdminContent />,
    name: 'Content',
  },
];

const theme = createTheme({
  status: {
    danger: '#e53e3e',
  },
  palette: {
    primary: {
      main: '#18397A',
      darker: '#18397A',
    },
    important: {
      main: '#d95e27',
      darker: '#bb5021',
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
    notSelected: {
      main: '#212121',
      contrastText: '#151515',
    },
  },
  box: {
    margin: '10px',
    padding: '60px 20px',
    borderRadius: '10px',
    backgroundColor: 'white',
  },
});

const AdminRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelectedContext((context) => context.user);
  const [breadcrumb, setBreadcrumb] = useState({
    path: '',
    name: '',
  });
  const [showNavbar, setShowNavbar] = useState(false);

  const [getCurrentUser] = useLazyQuery(GET_CURRENT_USER);

  const getUserValue = async () => {
    const userValue = await getCurrentUser();
    const isAdmin = userValue?.data?.currentUser?.roles?.findIndex((role) => role.name === 'admin');
    if (isAdmin !== undefined && isAdmin !== -1) {
      setShowNavbar(true);
    } else {
      navigate('/dashboard/feed', {
        replace: true,
        state: {
          isOpenNotification: true,
          openNotification: openNotification({
            type: 'error',
            message: 'Access denied',
          }),
        },
      });
      setShowNavbar(false);
    }
  };

  useEffect(() => {
    (async () => {
      await getUserValue();
    })();
  }, []);

  useEffect(() => {
    if (location && location.pathname) {
      const pathname = location.pathname.slice(6);
      const route = ADMIN_ROUTES_INFO.find((item) => item.path === pathname);
      if (route) {
        setBreadcrumb({
          path: route.path,
          name: route.name,
        });
      }
    }
  }, [location]);

  return (
    <PageContainer>
      <Box className={styles.pageContent}>
        <AdminNavbar
          showNavbar={showNavbar}
          theme={theme}
          baseUrl=""
          baseFceUrl={process.env.REACT_APP_DIGITAL_ASSETS || ''}
          baseApiUrl={process.env.REACT_APP_API || ''}
          baseAdminUrl={process.env.REACT_APP_ADMIN_URL || ''}
          mode="tt"
        />

        <div>
          <Breadcrumb
            data={[
              { href: '/', name: 'TransparenTerra' },
              { href: '/', name: 'Home' },
              { href: '/dashboard/feed', name: 'Admin' },
              { href: `/admin${breadcrumb.path}`, name: breadcrumb.name },
            ]}
          />
        </div>
        <Box className={styles.pageContentBox}>
          <Routes>
            {ADMIN_ROUTES_INFO.map((routeInfo) => (
              <Route path={routeInfo.path} element={routeInfo.element} key={routeInfo.path} />
            ))}
          </Routes>
        </Box>
      </Box>
    </PageContainer>
  );
};

export default AdminRoutes;
